import { Component } from '@angular/core';
import { CardHandler } from './card-component.handler';
import { Router } from '@angular/router';
import { SettingService } from 'src/app/system-common/services/setting.service';

@Component({
  selector: 'sym-card',
  templateUrl: './card-component.component.html',
  styleUrls: ['./card-component.component.scss'],
})
export class CardComponent extends CardHandler {
  constructor(public router: Router, public settingService: SettingService) {
    super(router, settingService);
  }

  ngOnInit() {}
}
